module.exports = __webpack_public_path__ + "static/img/buildsucesse.59ad0f4f.png";